import { List, ListItemButton, ListItemText, ListSubheader, Box, Typography } from '@mui/material';
import { KBarResults, useKBar } from 'kbar';
import { useMemo } from 'react';
import { buildOrderedKbarResults, getKbarSectionHeaderSx } from 'logic/custom-kbar-results';

export const CustomKbarResults = () => {
  const { actions, search } = useKBar((state) => ({
    actions: state.actions,
    search: state.searchQuery,
  }));
  const results = useMemo(
    () => buildOrderedKbarResults(Object.values(actions), search),
    [actions, search],
  );

  return (
    <List>
      <KBarResults
        items={results}
        onRender={({ item, active }) =>
          typeof item === 'string' ? (
            <ListSubheader
              disableSticky
              disableGutters
              sx={getKbarSectionHeaderSx(results.indexOf(item) === 0)}
            >
              {item}
            </ListSubheader>
          ) : (
            <ListItemButton
              selected={active}
              sx={{
                pr: 2.5,
              }}
            >
              <ListItemText
                primary={item.name}
                primaryTypographyProps={{
                  noWrap: true,
                }}
                sx={{ minWidth: 0 }}
              />
              <Box
                sx={{
                  ml: 1.25,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.25,
                  flexShrink: 0,
                }}
              >
                {item.shortcut && (
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    {item.shortcut.map((shortcut) => (
                      <Typography
                        key={shortcut}
                        variant="body2"
                        sx={{
                          color: 'text.secondary',
                          minWidth: '1rem',
                          textAlign: 'center',
                        }}
                      >
                        {shortcut}
                      </Typography>
                    ))}
                  </Box>
                )}
                {item.subtitle && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                      opacity: 0.58,
                      minWidth: '6.25rem',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {item.subtitle}
                  </Typography>
                )}
              </Box>
            </ListItemButton>
          )
        }
      />
    </List>
  );
};
